@if (fits) {
  <figure class="atable">
    <div class="atable__scroll" #scroll>
      <table class="grid grid--compact">
        <thead>
          <tr>
            @for (cell of table.header; track $index) {
              <th scope="col" [class.is-numeric]="table.numeric[$index]" [innerHTML]="cell"></th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of previewRows; track $index) {
            <tr>
              @for (cell of row; track $index) {
                <td [class.is-numeric]="table.numeric[$index]" [innerHTML]="cell"></td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    <button type="button" class="atable__open" (click)="open()">
      <mat-icon fontSet="material-icons-round" class="s-16" aria-hidden="true">open_in_full</mat-icon>
      @if (hiddenRows) {
        {{ allRowsLabel | translate: { count: table.rows.length } }}
      } @else {
        {{ 'Apri in grande' | translate }}
      }
    </button>
  </figure>
} @else {
  <button type="button" class="atable atable--card" (click)="open()">
    <mat-icon fontSet="material-icons-round" class="atable__icon" aria-hidden="true">table_chart</mat-icon>
    <span class="atable__summary">
      <span class="atable__size">{{ sizeLabel | translate: { rows: table.rows.length, columns: table.header.length } }}</span>
      <span class="atable__columns">{{ columnNames }}</span>
    </span>
    <span class="atable__cta">
      {{ 'Apri la tabella' | translate }}
      <mat-icon fontSet="material-icons-round" class="s-16" aria-hidden="true">open_in_full</mat-icon>
    </span>
  </button>
}
